module.exports = __webpack_public_path__ + "static/media/cecautoWhite@3x.98a13b0e.png";